import script from "./NewVideoCom.vue?vue&type=script&setup=true&lang=js"
export * from "./NewVideoCom.vue?vue&type=script&setup=true&lang=js"

import "./NewVideoCom.vue?vue&type=style&index=0&id=258ed472&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-258ed472"]])

export default __exports__